/**
 * Checks if teacher is teaching in this subject for a student
 * @params {string} subjectId
 * @params {string} studentId
 * @params {educationPeriod}
 * @params {array} teacherSubjects The list of subjects provided by me query
 * @returns {boolean} If the student was found for a subject in one of the subject classes
 * */
const isSubjectAvailable = ({
  subjectId,
  studentId,
  educationPeriod: ep,
  teacherSubjects = [],
}) => {
  if (
    !subjectId ||
    !studentId ||
    !ep ||
    !Array.isArray(teacherSubjects) ||
    !teacherSubjects.length
  )
    return false;

  const currentEducationPeriod = Number.parseInt(ep, 10);
  const { classes } = teacherSubjects.find(({ id }) => id === subjectId) || {};
  const classesForThisEP = ((Array.isArray(classes) && classes) || []).filter(
    ({ educationPeriod }) => educationPeriod === currentEducationPeriod,
  );
  const studentFoundInClass = (
    (Array.isArray(classesForThisEP) && classesForThisEP) ||
    []
  ).find(({ students }) =>
    ((Array.isArray(students) && students) || []).find(
      ({ id }) => id === studentId,
    ),
  );

  return Boolean(studentFoundInClass);
};

export default isSubjectAvailable;
